import Component from '@glimmer/component'
import config from 'district-ui-client/config/environment'
import { service } from '@ember/service'
import type SessionService from 'district-ui-client/services/session'
import type Owner from '@ember/owner'
import type Store from 'ember-data/store'
import { SubscriptionType } from 'district-ui-client/domain/subscription-type'

export class WalkMe extends Component {
  @service session!: SessionService
  @service store!: Store

  get shouldLoadWalkMe() {
    return config.walkme.enabled
  }

  get loadScript() {
    return config.walkme.loadScript
  }

  get is3PRoster() {
    return this.session.currentDistrict.oneRosterEnabled === true
  }

  get isCleverManaged() {
    const district = this.session.currentDistrict
    return Boolean(district.usesExternalRostering && district.externalRosteringSource === 'clever')
  }

  get isClassLinkManaged() {
    const district = this.session.currentDistrict
    return Boolean(district.usesExternalRostering && district.externalRosteringSource === 'classlink')
  }

  get subscriptionTypes() {
    return this.session.currentDisco.subscriptionTypes
  }

  constructor(owner: Owner, args: never) {
    super(owner, args)
    this.setGlobals()
  }

  setGlobals() {
    window.walkme3P = window.walkme3P || {}

    Object.defineProperties(window.walkme3P, {
      countryCode: {
        get: () => this.session.currentDisco.countryCode,
        enumerable: true,
      },
      is3PRoster: {
        get: () => this.is3PRoster,
        enumerable: true,
      },
      isCleverManaged: {
        get: () => this.isCleverManaged,
        enumerable: true,
      },
      isClassLinkManaged: {
        get: () => this.isClassLinkManaged,
        enumerable: true,
      },
      discoRE: {
        get: () => this.subscriptionTypes.includes(SubscriptionType.Reading),
        enumerable: true,
      },
      discoMS: {
        get: () => this.subscriptionTypes.includes(SubscriptionType.Maths),
        enumerable: true,
      },
      discoMX: {
        get: () => this.subscriptionTypes.includes(SubscriptionType.Mathletics),
        enumerable: true,
      },
    })
  }

  willDestroy(): void {
    super.willDestroy()

    delete window.walkme3P
  }

  <template>
    {{#if this.shouldLoadWalkMe}}
      {{! template-lint-disable no-forbidden-elements }}
      <script type="text/javascript" async src={{this.loadScript}} data-test-walkme-script></script>
    {{/if}}
  </template>
}
